/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { FC, SVGProps } from 'react';

const AccountManagerIcon: FC<SVGProps<SVGSVGElement> & { size?: number; color?: string }> = ({
  size = '20',
  color = '#7A7A7A',
  ...props
}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 20 20" fill="none" {...props}>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.7257 16.6672L16.0682 14.0642L15.2874 12.6725H12.1641L11.3833 14.0642L13.7257 16.6672Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.93213 16.5177C3.93213 14.7801 5.30378 12.6172 9.25392 12.6172"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.6533 6.73281C12.6533 8.60987 11.131 10.1322 9.25392 10.1322C7.37682 10.1322 5.85449 8.60987 5.85449 6.73281C5.85449 4.85496 7.37682 3.33337 9.25392 3.33337C11.131 3.33337 12.6533 4.85496 12.6533 6.73281Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default AccountManagerIcon;
